import i18n from '@/utils/i18n';

const fields =
  {
    account_details: {
      title: i18n.t('users.editing.account_details'),
      items: [
        {
          name: "email",
          type: "email",
          required: true,
          label: i18n.t('users.email'),
          autocomplete: 'new-email'
        },
        {
          name: "first_name",
          type: "text",
          label: i18n.t('users.first_name'),
          autocomplete: 'off'
        },
        {
          name: "last_name",
          type: "text",
          label: i18n.t('users.last_name'),
          autocomplete: 'off'
        },
        {
          name: "phone",
          type: "tel",
          label: i18n.t('users.phone'),
          autocomplete: 'off'
        },
        {
          name: "team_id",
          type: "select",
          label: i18n.t('users.create.attached_team'),
          placeholder: i18n.t('form.type_to_search'),
          options_url: "teams?limit=100",
          searchable: true,
          filter_field: 'name'
        },
        {
          name: "company",
          type: "text",
          label: i18n.t('users.company'),
          autocomplete: 'off'
        },
        {
          name: "job",
          type: "text",
          label: i18n.t('users.job'),
          autocomplete: 'off'
        },
        {
          name: "country",
          allow_empty: false,
          type: "select",
          label: i18n.t('users.country'),
          options_url: "countries"
        },
        {
          name: "state",
          allow_empty: false,
          type: "select",
          label: i18n.t('users.state'),
        },
        {
          name: "city",
          type: "text",
          label: i18n.t('users.city'),
          autocomplete: 'off'
        },
        {
          name: "language",
          type: "select",
          label: i18n.t('users.language'),
          options_url: 'languages',
          placeholder: null,
        },
        {
          name: "zip",
          type: "text",
          label: i18n.t('users.zip'),
          autocomplete: 'off'
        },
        {
          name: "address",
          type: "text",
          label: i18n.t('global.address'),
          autocomplete: 'off'
        },
        {
          name: "password",
          type: "password",
          label_editing: i18n.t('users.new_password'),
          label: i18n.t('users.password'),
          autocomplete: 'new-password'
        }
      ]
    },
    switchers_details: {
      items: [
        {
          name: "confirm",
          type: "switch",
          label: i18n.t('users.editing.confirmed')
        },
        {
          name: "active",
          type: "switch",
          label: i18n.t('users.editing.account_status'),
          title: i18n.t('user_status.true'),
          titleFalse: i18n.t('user_status.false')
        }
      ]
    },
    switchers: {
      items: [
        {
          name: "locked",
          type: "switch",
          label: i18n.t('users.editing.locked'),
        },
        {
          name: "never_lock",
          field: 'settings',
          type: "switch",
          label: i18n.t('users.editing.never_locked'),
        },
        {
          name: "never_compromised",
          field: 'settings',
          type: "switch",
          label: i18n.t('users.editing.never_compromised'),
        },
      ]
    },
    tags: {
      title: i18n.t('form.tags'),
      items: [
        {
          name: "tags",
          type: "select",
          label: i18n.t('form.tags'),
          options: [],
          taggable: true,
          multiple: true,
          searchable: true
        },
        {
          name: "limit",
          type: "checkbox",
          label: ""
        }
      ]
    }
  };

export default fields
